'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactOcticons = require('react-octicons');

require('./GithubUser.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GithubUser = function (_Component) {
  _inherits(GithubUser, _Component);

  function GithubUser() {
    _classCallCheck(this, GithubUser);

    var _this = _possibleConstructorReturn(this, (GithubUser.__proto__ || Object.getPrototypeOf(GithubUser)).call(this));

    _this.state = {
      isLoading: true,
      user: {}
    };

    _this.closing = false;
    return _this;
  }

  _createClass(GithubUser, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (this.props.objUser) {
        this.setState({
          isLoading: false,
          user: this.props.objUser || {}
        });
      } else {
        window.fetch('https://api.github.com/users/' + this.props.name).then(function (response) {
          return response.json();
        }).then(function (json) {
          if (_this2.closing) {
            return;
          }

          _this2.setState({
            isLoading: false,
            user: json || {}
          });
        }).catch(function (ex) {
          _this2.setState({
            isLoading: false
          });
          throw ex;
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.objUser) {
        this.setState({
          user: props.objUser || {}
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.closing = true;
    }
  }, {
    key: 'fixHttp',
    value: function fixHttp(url) {
      if (url && !url.startsWith('http')) {
        return 'http://' + url;
      }

      return url;
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var isHireable = this.state.user.hireable;
      var accountType = this.state.user.type;

      var avatar = _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_reactOcticons.OctofaceIcon, { className: 'rsg-loading-icon' })
      );
      var classes = "rsg-github-wrapper rsg-github-user";

      if (this.state.user.avatar_url !== undefined) {
        avatar = _react2.default.createElement('img', {
          alt: this.state.user.login || '',
          className: 'rsg-avatar',
          src: this.state.user.avatar_url || ''
        });
      } else {
        classes = "rsg-github-is-loading";
      }

      return _react2.default.createElement(
        'div',
        { className: classes },
        avatar,
        _react2.default.createElement(
          'span',
          { className: 'rsg-name' },
          this.state.user.name
        ),
        isHireable && _react2.default.createElement(
          'div',
          { className: 'rsg-status' },
          _react2.default.createElement(
            'span',
            { className: 'rsg-available' },
            'Available for hire'
          )
        ),
        _react2.default.createElement(
          'a',
          {
            className: 'rsg-info',
            href: this.fixHttp(this.state.user.blog),
            target: '_blank'
          },
          this.state.user.blog
        ),
        _react2.default.createElement(
          'span',
          { className: 'rsg-info' },
          this.state.user.company
        ),
        _react2.default.createElement(
          'span',
          { className: 'rsg-info' },
          this.state.user.location
        ),
        _react2.default.createElement(
          'div',
          { className: 'rsg-counters' },
          _react2.default.createElement(
            'div',
            { className: 'rsg-item' },
            _react2.default.createElement(
              'div',
              { className: 'rsg-icon' },
              _react2.default.createElement(_reactOcticons.RepoIcon, null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'rsg-description' },
              _react2.default.createElement(
                'div',
                { className: 'rsg-count' },
                Number(this.state.user.public_repos || 0).toLocaleString()
              ),
              _react2.default.createElement(
                'div',
                { className: 'rsg-label' },
                this.state.user.public_repos > 1 ? "Repos" : "Repo"
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'rsg-item' },
            _react2.default.createElement(
              'div',
              { className: 'rsg-icon' },
              _react2.default.createElement(_reactOcticons.GistIcon, null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'rsg-description' },
              _react2.default.createElement(
                'div',
                { className: 'rsg-count' },
                Number(this.state.user.public_gists || 0).toLocaleString()
              ),
              _react2.default.createElement(
                'div',
                { className: 'rsg-label' },
                this.state.user.public_gists > 1 ? "Gists" : "Gist"
              )
            )
          )
        ),
        accountType === "User" && _react2.default.createElement(
          'a',
          {
            className: 'rsg-btn rsg-btn-github',
            href: "https://github.com/" + this.state.user.login,
            target: '_blank'
          },
          _react2.default.createElement(_reactOcticons.MarkGithubIcon, { className: 'rsg-icon' }),
          _react2.default.createElement(
            'span',
            { className: 'rsg-text' },
            'Follow @',
            this.state.user.login
          )
        ),
        accountType === "Organization" && _react2.default.createElement(
          'a',
          {
            className: 'rsg-btn rsg-btn-github',
            href: "https://github.com/" + this.state.user.login,
            target: '_blank'
          },
          _react2.default.createElement(_reactOcticons.OrganizationIcon, { className: 'rsg-icon' }),
          _react2.default.createElement(
            'span',
            { className: 'rsg-text' },
            'View @',
            this.state.user.login
          )
        )
      );
    }
  }]);

  return GithubUser;
}(_react.Component);

GithubUser.propTypes = {
  // name
  name: _propTypes2.default.string,

  // objUser
  objUser: _propTypes2.default.object
};

exports.default = GithubUser;